import { Box } from "@mui/joy";
import RestaurantOutlinedIcon from '@mui/icons-material/RestaurantOutlined';

export function TriedBadge({ tried }) {
  if (!tried) {
    return null;
  }

  return (
    <Box
      title="Tried"
      sx={{
        position: 'absolute',
        bottom: 8,
        left: 8,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 28,
        height: 28,
        borderRadius: '50%',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        color: 'neutral.600',
      }}
    >
      <RestaurantOutlinedIcon sx={{ fontSize: 16 }} />
    </Box>
  );
}
